import script from "./AuthorizationGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthorizationGuide.vue?vue&type=script&setup=true&lang=js"

import "./AuthorizationGuide.vue?vue&type=style&index=0&id=13a9a138&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13a9a138"]])

export default __exports__